module.exports = __webpack_public_path__ + "img/18.a060bac6.jpg";